export default "__VITE_ASSET__BOEOyN63__"